module.exports = __webpack_public_path__ + "img/IconWarning.9e18d4b9.svg";